import { pageInfo, matDetails, exceptionReason ,signSubmit, signBatchSubmit, downloadTemplate, exportData, importData ,uploadFile, signDetails, receiptBatchSubmit, signBack, receiptSubmit, uploadReceiptCheck, receiptConfirm} from '../api/index';
import { listShipper, listShipType } from '../../../api/selects';
import { Message } from 'element-ui';
import { companyListData } from '../../mdm/company/api';
import {
  getListCarrier,
} from '../../../api/index'
const sign = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exceptionReasonObj: null,
    matDetailsObj: null,
    shipperObj: null,
    signSubmitObj: null,
    signBatchSubmitObj: null,
    downloadTemplateObj: null,
    importDataObj: null,
    exportDataObj: null,
    shipTypeObj: null,
    uploadFileObj: null,
    signDetailsObj: null,
    receiptBatchSubmitObj: null,
    receiptSubmitObj: null,
    signBackObj: null,
    uploadReceiptCheckObj: null,
    receiptConfirmObj: null,
    companyObj: null,
    carrierObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
     // state.pageResp = data.obj || [];
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [(item.orderStatusNo == '40' || item.orderStatusNo == '30'), (item.orderStatusNo != '40' && item.orderStatusNo != '30'), (item.receiptPdfList != null && item.receiptPdfList.length > 0),(item.receiptImageList != null && item.receiptImageList.length > 0),  (item.orderStatusNo == '50' || item.orderStatusNo == '60')] }));

    },
    LIST_SHIPPER(state, data) {
      state.shipperObj = data.obj;
    },
    MAT_DETAILS(state, data) {
      state.matDetailsObj = data.obj;
    },
    EXCEPTION_REASON(state, data) {
      state.exceptionReasonObj = data.obj;
    },
    SIGN_SUBMIT(state, data) {
      state.signSubmitObj = data;
    },
    SIGN_BATCH_SUBMIT(state, data) {
      state.signBatchSubmitObj = data;
    },
    DOWNLOAD_TEMPLATE(state, data) {
      state.downloadTemplateObj = data;
    },
    IMPORT_DATA(state, data) {
      state.importDataObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    LIST_SHIP_TYPE(state, data) {
      state.shipTypeObj = data.obj;
    },
    SIGN_DETAILS(state, data) {
      state.signDetailsObj = data;
    },
    RECEIPT_BATCH_SUBMIT(state, data) {
      state.receiptBatchSubmitObj = data;
    },
    RECEIPT_SUBMIT(state, data) {
      state.receiptSubmitObj = data;
    },
    SIGN_BACK_SUBMIT(state, data) {
      state.signBackObj = data;
    },
    //上传附件
    UPLOAD_FILE(state, data) {
      state.uploadFileObj = data;
    },
    //上传附件
    UPLOAD_RECEIPT_CHECK(state, data) {
      state.uploadReceiptCheckObj = data;
    },
    RECEIPT_CONFIRM(state, data) {
      state.receiptConfirmObj = data;
    },
    LIST_COMPANY(state, data) {
      state.companyObj = data.obj;
    },
    //承运商下拉框数据
    GET_LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
  },
  actions: {
    //查询
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },

    //签收
    async signSubmit({ commit }, obj) {
      let resp = await signSubmit(obj);
      commit('SIGN_SUBMIT', resp);
    },
    //批量签收
    async signBatchSubmit({ commit }, obj) {
      let resp = await signBatchSubmit(obj);
      commit('SIGN_BATCH_SUBMIT', resp);
    },
    /*异常签收原因*/
    async exceptionReason({ commit }, obj) {
      let resp = await exceptionReason(obj);
      commit('EXCEPTION_REASON', resp);
    },
    /*订单明细*/
    async matDetails({ commit }, obj) {
      let resp = await matDetails(obj);
      commit('MAT_DETAILS', resp);
    },
    /*主数据-货主*/
    async listShipper({ commit }, obj) {
      let resp = await listShipper(obj);
      commit('LIST_SHIPPER', resp);
    },
    //下载模板
    async downloadTemplate({ commit }, obj) {
      let resp = await downloadTemplate(obj);
      commit('DOWNLOAD_TEMPLATE', resp);
    },
    //导入数据
    async importData({ commit }, obj) {
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //运输类型
    async listShipType({ commit }, obj) {
      let resp = await listShipType(obj);
      commit('LIST_SHIP_TYPE', resp);
    },

    /*签收详情*/
    async signDetails({ commit }, obj) {
      let resp = await signDetails(obj);
      commit('SIGN_DETAILS', resp);
    },
    //批量回单
    async receiptBatchSubmit({ commit }, obj) {
      let resp = await receiptBatchSubmit(obj);
      commit('RECEIPT_BATCH_SUBMIT', resp);
    },
    //回单上传提交
    async receiptSubmit({ commit }, obj) {
      let resp = await receiptSubmit(obj);
      commit('RECEIPT_SUBMIT', resp);
    },
    //回退签收
    async signBack({ commit }, obj) {
      let resp = await signBack(obj);
      commit('SIGN_BACK_SUBMIT', resp);
    },

    /**
     * 上传回单
     */
    async uploadFile({commit}, obj) {
      let resp = await uploadFile(obj);
      commit('UPLOAD_FILE', resp);
    },
    /**
     * 上传回单并校验订单
     */
    async uploadReceiptCheck({commit}, obj) {
      let resp = await uploadReceiptCheck(obj);
      commit('UPLOAD_RECEIPT_CHECK', resp);
    },
    //回单确认
    async receiptConfirm({ commit }, obj) {
      let resp = await receiptConfirm(obj);
      commit('RECEIPT_CONFIRM', resp);
    },
    /**
     * 机构查询
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
    /**
     * 获取承运商下拉框数据
     * @param commit
     * @param obj
     * @returns {Promise<void>}
     */
    async getListCarrier({commit}, obj) {
      let resp = await getListCarrier(obj);
      commit('GET_LIST_CARRIER', resp);
    },
  }
}
export default sign



// WEBPACK FOOTER //
// ./src/page/sign/store/sign.store.js